import { addSheetBackLink, PARENT_SHEETS } from "../sheetNavigation";

const HEADER_FILL = {
  type: "pattern",
  pattern: "solid",
  fgColor: { argb: "FFB9D1EA" },
};

const COLUMN_HEADER_FILL = {
  type: "pattern",
  pattern: "solid",
  fgColor: { argb: "FFD9D9D9" },
};

const THIN_BLACK = {
  top: { style: "thin", color: { argb: "FF000000" } },
  left: { style: "thin", color: { argb: "FF000000" } },
  bottom: { style: "thin", color: { argb: "FF000000" } },
  right: { style: "thin", color: { argb: "FF000000" } },
};

const BODY_FONT = { name: "Calibri", size: 11 };
const LINK_FONT = {
  name: "Calibri",
  size: 11,
  color: { argb: "FF0563C1" },
  underline: true,
};

const NIC_CODE_LIST_URL = "https://www.ncs.gov.in/Documents/NIC_Sector.pdf";

const COL_START = 4; // D
const COL_END = 7; // G
const TITLE_ROW = 3;
const HEADER_ROW = 4;
const DATA_START_ROW = 5;

function borderCell(cell) {
  cell.border = THIN_BLACK;
}

function setCell(ws, row, col, value, options = {}) {
  const cell = ws.getCell(row, col);
  cell.value = value;
  cell.font = options.bold ? { ...BODY_FONT, bold: true } : BODY_FONT;
  borderCell(cell);
  cell.alignment = {
    horizontal: options.align || "center",
    vertical: "middle",
    wrapText: true,
  };
  if (options.fill) cell.fill = options.fill;
}

function formatTurnoverPct(value) {
  if (value === null || value === undefined || value === "") return "";
  const str = String(value).trim();
  if (str.endsWith("%")) return str;
  const num = Number(value);
  if (Number.isNaN(num)) return str;
  return `${num.toFixed(2)}%`;
}

export function buildProductsServicesSoldSheet(workbook, sectionA) {
  const ws = workbook.addWorksheet("Products services sold", {
    views: [{ showGridLines: true }],
  });

  const widths = { A: 2, B: 2, C: 2, D: 8, E: 28, F: 14, G: 22 };
  Object.entries(widths).forEach(([col, width]) => {
    ws.getColumn(col).width = width;
  });

  addSheetBackLink(ws, PARENT_SHEETS.GENERAL_DISCLOSURES, { mergeEnd: COL_END });

  const products = sectionA?.productServices?.productsOrServices || [];

  ws.mergeCells(TITLE_ROW, COL_START, TITLE_ROW, COL_END);
  const tableTitle = ws.getCell(TITLE_ROW, COL_START);
  tableTitle.value =
    "Products/Services sold by the entity (accounting for 90% of the entity's Turnover)";
  tableTitle.font = { ...BODY_FONT, bold: true };
  tableTitle.fill = HEADER_FILL;
  borderCell(tableTitle);
  tableTitle.alignment = { horizontal: "center", vertical: "middle", wrapText: true };

  const headers = [
    { col: COL_START, label: "Sr. No." },
    { col: 5, label: "Product/Service" },
    { col: 6, label: "NIC Code" },
    { col: COL_END, label: "% of total Turnover contributed" },
  ];

  headers.forEach(({ col, label }) => {
    setCell(ws, HEADER_ROW, col, label, { bold: true, fill: COLUMN_HEADER_FILL, align: "center" });
  });

  const rows = products.length ? products : [{}];

  rows.forEach((item, idx) => {
    const row = DATA_START_ROW + idx;
    setCell(ws, row, COL_START, String(idx + 1), { align: "center" });
    setCell(ws, row, 5, item?.productOrService ?? "", { align: "left" });
    setCell(ws, row, 6, item?.nicCode ?? "", { align: "center" });
    setCell(ws, row, COL_END, formatTurnoverPct(item?.turnoverPercentage), {
      align: "right",
    });
  });

  const nicLinkRow = DATA_START_ROW + rows.length + 1;
  const nicLabel = ws.getCell(nicLinkRow, 5);
  nicLabel.value = "NIC Code list link:";
  nicLabel.font = { ...BODY_FONT, color: { argb: "FFFF0000" } };
  nicLabel.alignment = { horizontal: "left", vertical: "middle" };

  const nicLink = ws.getCell(nicLinkRow, 6);
  nicLink.value = {
    text: NIC_CODE_LIST_URL,
    hyperlink: NIC_CODE_LIST_URL,
  };
  nicLink.font = LINK_FONT;
  nicLink.alignment = { horizontal: "left", vertical: "middle" };

  return ws;
}
